import React, { Component } from "react";
import PropTypes from "prop-types";
import "../../sass/components/customMessage/index.css";


/*
*Custom Underline Message
*/
class CustomMessages extends Component {


    render() {
        const { text } = this.props
        return (
            <div className="custom-messgaes background">
                <span>{text}</span>
            </div>
        );
    }
}

CustomMessages.propTypes = {

    /**Text string to display */
    text: PropTypes.string

};

export default CustomMessages;


// WEBPACK FOOTER //
// ./src/components/CustomMessage/CustomMessages.js